import React, { useState, useMemo } from 'react';
import { Job } from '../types';

interface Props {
  jobs: Job[];
}

const EstimatedEarningsCalculator: React.FC<Props> = ({ jobs }) => {
  const [selectedJobIds, setSelectedJobIds] = useState<Set<string>>(new Set());

  const toggleJob = (jobId: string) => {
    const newSelected = new Set(selectedJobIds);
    if (newSelected.has(jobId)) {
      newSelected.delete(jobId);
    } else {
      newSelected.add(jobId);
    }
    setSelectedJobIds(newSelected);
  };

  const totalEarnings = useMemo(() => {
    return jobs
      .filter(job => selectedJobIds.has(job.id))
      .reduce((sum, job) => sum + (job.totalPrice || 0), 0);
  }, [jobs, selectedJobIds]);

  return (
    <div className="bg-white p-6 rounded-2xl border-2 border-stone-200 shadow-sm space-y-4">
      <h3 className="text-xl font-bold text-bark">Estimated Earnings</h3>
      
      <div className="space-y-2 max-h-60 overflow-y-auto">
        {jobs.map(job => (
          <div key={job.id} className="flex items-center space-x-3 p-2 hover:bg-stone-50 rounded-lg">
            <input 
              type="checkbox" 
              checked={selectedJobIds.has(job.id)}
              onChange={() => toggleJob(job.id)}
              className="w-5 h-5 rounded border-stone-300 text-palm focus:ring-palm"
            />
            <div className="flex-1">
              <p className="font-bold text-sm text-bark">{job.clientName}</p>
              <p className="text-xs text-stone-500">${job.totalPrice?.toFixed(2) || '0.00'}</p>
            </div>
          </div>
        ))}
      </div>

      <div className="pt-4 border-t border-stone-200 flex justify-between items-center">
        <p className="text-stone-500 font-bold uppercase text-xs">Total Selected</p>
        <p className="text-2xl font-bold text-gecko">${totalEarnings.toFixed(2)}</p>
      </div>
    </div>
  );
};

export default EstimatedEarningsCalculator;
